<!-- <mat-dialog-actions align="end" class="p-0" style="min-height: 0;">
    <mat-icon mat-dialog-close style="color: var(--color-primary); cursor: pointer; font-size: 32px; margin-right: 10px;">highlight_off</mat-icon>
</mat-dialog-actions> -->
<div class="row mt-4">
    <div class="col-12 text-center mb-4">
        <img src="./assets/img/success.svg" alt="">
    </div>
    <div class="col-12 text-center">
        <p class="text-color-secondary font-semi-bold mb-2 font-title">{{subject}}</p>
        <p *ngIf="value" class="text-color-secondary mb-2" style="font-size: 17px;">{{value}}</p>
    </div>
    <div class="col-12 text-center my-3">
        <button mat-dialog-close mat-flat-button class="style-button-1 mt-2 w-30  mat-elevation-z3" (click)="onClose()">
            <span>Finalizar</span>
        </button>
    </div>
</div>

